export enum SchoolType {
  Public = 'Public',
  Independent = 'Independent',
  Selective = 'Selective',
  International = 'International',
  Other = 'Other',
}
